// extracted by mini-css-extract-plugin
export default {"updated":"TermOfUse_updated__Vse7Z","main":"TermOfUse_main__4CcNZ","article":"TermOfUse_article__lk01Z","table":"TermOfUse_table__KRH-p"};